import Vue from 'vue'
import { APP_SHOW_MODE_ENUM, NEIGHBOR_GROUP } from '@/utils/enums'


export function hexToRgb(hex) {
  const r = parseInt(hex.substring(1, 3), 16)
  const g = parseInt(hex.substring(3, 5), 16)
  const b = parseInt(hex.substring(5, 7), 16)
  return { r, g, b }
}


export function deepCopy(target) {
  if (typeof target === 'object') {
    const result = Array.isArray(target) ? [] : {}
    for (const key in target) {
      if (typeof target[key] === 'object') {
        result[key] = deepCopy(target[key])
      } else {
        result[key] = target[key]
      }
    }

    return result
  }

  return target
}

export function swap(arr, i, j) {
  const temp = arr[i]
  arr[i] = arr[j]
  Vue.set(arr, i, arr[j])
  Vue.set(arr, j, temp)
}

export function $(selector) {
  return document.querySelector(selector)
}

/**
 * 在数组中查找指定的项 ，支持多维数组 ，数组对象嵌套
 *
 * @param arr 被查找的数组
 * @param children 当被查找项是对象时（ 数组对象嵌套 ）这个参数作为子集合属性名称 ，如果是多维数组不会有任何影响
 * @return undefined | Object | *
 */
export function flatten(arr, childen = 'child') {
  return arr.reduce((a, b) => {
    return Array.isArray(b[childen]) ? a.concat(flatten(b[childen])) : a.concat(b)

    //   return a.concat(Array.isArray(b[childen]) ? flatten(b[childen]) : b);
  }, [])
}

/**
 * 获取设备状态图片
 * @param params 设备全部参数
 * @return 图片链接
 */

export function getImgUrlState(params, type) {
  if (params?.IconUrl?.Line) {
    const url = new URL(params.IconUrl.Line)
    const pathParts = url.pathname.split('/')
    pathParts[pathParts.length - 1] = type
    url.pathname = pathParts.join('/')
    return url.toString()
  } else {
    return '/static/@opple/commercial-lighting-resource/JS/resource/icon/default.png'
  }
}

/**
 * @param vDeviceId
 * @param channelId
 * @return 唯一标识
 */
export function genUnionID(vDeviceId, channelId) {
  return vDeviceId + '-' + channelId
}

/**
 * 判断
 * @param msg  设备
 * @param type '0X0100' || '0X02'
 * @param value
 * @return 灯状态
 */
export function getdeviceImageStatus(msg, type, value) {
  let result = null
  if (msg != null && msg.StatusInfo != null) {
    const info = typeof msg.StatusInfo === 'object' ? msg.StatusInfo : JSON.parse(msg.StatusInfo)
    for(let i=0;i<info.length;i++){
      const model = info[i]
      /* 面板类型无开关状态，常开 */
      if ( type === '0X02' && msg.ChildCategoryType === 4) {
        break;
      }
      if (
        // model.IsTop &&
        model.StatusType.toUpperCase().indexOf(type.toUpperCase()) >= 0 &&
        (msg.ChildId != 65535 ? model.ChannelId == msg.ChildId : true) &&
        (msg.ChildId == 65535 ? msg.ClassSku.toUpperCase() != '0X001C3003' : true)
      ) {
        if (model.Value == value || model.Value1 == value) {
          result = true
          break
        } else {
          result = false
          break
        }
      }
    }
  }
  return result
}

export function getSortType() {
  return +sessionStorage.getItem('selectedSortType')
}

/**
 * 保留小数点几位数, 自动补零, 四舍五入
 * @param num: 数值
 * @param digit: 小数点后位数
 * @returns string
 */
export function myFixed(num, digit) {
  if (Object.is(parseFloat(num), NaN)) {
    return console.log(`传入的值：${num}不是一个数字`)
  }
  num = parseFloat(num)
  return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit)
}

// 判断字符串 是否为非空字符串
export function isNull(str) {
  if (str === null || str === '' || str === undefined) {
    return false
  }
  return true
}

/**
 * 根据能力列表判断单能力是否满足UI显示条件  列如满足开关、模式等
 * @param data: 设备的单能力
 * @param list: 设备动作能力列表
 * @param type: 0是详情，1是场景，2是自动化
 * @returns Boolean
 */

export function isMatched(data, list, type = 0) {
  //单设备的UI能力
  function Detail (){
    return data?.UI?.ShowCondition?.status
  }

  //UI能力表的配置
  function UIability (){
    return data?.ShowCondition?.status
  }

  //如果没有找到ShowCondition或者status就直接显示能力
  if (!(Detail() || UIability())) {
    return true
  }

  /* 设备详情能力单独判断 */
  try {
    if (type === 0) {
      list = list.flatMap(item => {
        return item.ActionList
      })
    }
  } catch (error) {}
  let match = false
  try {
    const showConditions = data?.UI?.ShowCondition?.status || data?.showConditions?.status || []

    match = showConditions.some(single => {
      // 大循环都是且的关系； 只要有一条不符合就不显示
      let { condition, relation } = single
      let sum = condition.reduce((total, item) => {
        let type = item['type']
        let value = item['value']

        const newList = list.flatMap(item => {
          return item.Values
        })
        const filterNewList = newList.filter(item => {
          return item.Type == type
        })
        //亮度存在范围取值0-2
        if ( filterNewList.length>0 &&  filterNewList[0].Type == '0x0300') {
          const needShow = filterNewList[0].DefaultValue < value
          return needShow ? ++total : total
        }
        if(filterNewList.length>0){
          let deviceValue =  filterNewList[0].DefaultValue
          let needShow = deviceValue == value
          return needShow ? ++total : total
        }

        return total
      }, 0)
      // 且的关系 满足条件的和要和条件一致  或的关系 只有一条需要满足
      
      let show = relation == 1 ? sum == condition.length : sum > 0

      if (data.Desc === "调色") {
         console.log('data data', relation, sum, condition, data, !show);
      }

      return !show
    })
  } catch (error) {
    console.log('....error',error)
  }
  return !match
}

export const hexStr2Value = (hexStr, index, length) => {
  let value = parseInt(hexStr.substr(index * 2, 2 * length), 16)
  return value
}

export const computedColors = value => {
  let Result = []
  try {
    for (var i = 0; i < value.length / 8; i++) {
      Result[i] = hexStr2Value(value, i * 4, 4)
    }
  } catch (error) {}
  return Result
}

/**
 * 判断能力显示权限
 * showMode
 * -1是全部显示
 * 0是全部不显示
 * 1是详情
 * 2是场景
 * 4是自动化
 * appShowMode
 * 1是详情
 * 2是场景
 * 4是自动化
 * @param tem 设备的单条能力
 * @param type 1、场景，2、自动化
 * action 里面增加了UISort,通过能力表UIconfig里面的UISort来判断是否显示,权重最高 2024-7-17
 */

export const getAppShowMode = (tem, type = 0) => {
  if (!Object.values(APP_SHOW_MODE_ENUM).includes(type)) {
    throw new Error('Invalid type value.')
  }
  var _tem = tem && tem.UI
  _tem = _tem && _tem.ShowCondition
  _tem = _tem && _tem.appShowMode
  const old_tem = tem.ShowMode
  let _show = false
  if (old_tem == 0) {
    _show=false
    // return false
  } else if (_tem != null) {
    let _value = type == 2 ? 0b100 : type == 1 ? 0b010 : 0b001
    _show = (_tem & _value) === _value
    // return (_tem & _value) === _value
  } else if (old_tem === -1) {
     _show = true
    //  return true
  } else {
    let _value = type == 2 ? 0b100 : type == 1 ? 0b010 : 0b001
    _show = (old_tem & _value) === _value
    // return (old_tem & _value) === _value
  }
  if(!_show &&  type === APP_SHOW_MODE_ENUM.DEVICE && tem.hasOwnProperty('UISort')) {
    return true 
  }
  return _show
}

/**
 * 设备详情
 * @param tem 设备的单条能力
 */
export const getDeviceShowMode = tem => {
  return getAppShowMode(tem, APP_SHOW_MODE_ENUM.DEVICE)
}

/**
 * 场景
 * @param tem 设备的单条能力
 */
export const getSenceShowMode = tem => {
  return getAppShowMode(tem, APP_SHOW_MODE_ENUM.SENCE)
}

/**
 * 自动化
 * @param tem 设备的单条能力
 */
export const getIftttShowMode = tem => {
  return getAppShowMode(tem, APP_SHOW_MODE_ENUM.IFTTT)
}

/**
 * 捕获require动态导入不存在图片报错
 * 当解析出来的映射内部没有匹配值时, 内部会throw error (eg: 'Cannot find module xxx')
 * 这个函数用来捕获require错误
 * @param {*} requireFn - eg: () => require(`./xxx/${变量}.png`)
 */
export function catchRequireErr(requireFn,defaultfn) {
  let url = ''
  try {
    requireFn && (url = requireFn())
  } catch (error) {
    console.log('error: ', error)
    defaultfn && (url = defaultfn())
  }
  return url
}
export function debounce(func, delay = 200) {
  let timer
  return function () {
    const _this = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      func.apply(_this, args)
    }, delay)
  }
}

/** 是否为开发环境 */
export function isDev() {
  return process.env.NODE_ENV === 'development'
}

/** 是否本地服务/内网部署 */
export function isLocalServer() {
  return process.env.VUE_APP_MODE === 'local-server'
}

/** 欧洲环境 */
export function isIot1() {
  return process.env.VUE_APP_MODE?.indexOf('iot1') > -1 || process.env.VUE_APP_MODE?.indexOf('iot1-uat') > -1
}

/** 新加坡环境 */
export function isIot3() {
  return process.env.VUE_APP_MODE?.indexOf('iot3') > -1
}


export function encodeNeighborGroup(arr) {
  if (!(arr.length > 0)) {
    return ''
  }
  const offset = Number(NEIGHBOR_GROUP)
  const hexArray = arr.map(value => {
    const result = (value + offset).toString(16)
    return result.substring(result.length - 4)
  })
  return arr.length.toString(16).padStart(2, '0') + hexArray.join('')
}

export function decodeNeighborGroup(hexString) {
  /* 强转后0为空值 */
  if ( !hexString && !isNaN(+this.item.DefaultValue)) {
    return []
  }
  const offset = Number(NEIGHBOR_GROUP)
  const hexArray = hexString.slice(2).match(/.{1,4}/g) // 每四个字符一组
  const decimalArray = hexArray.map(hex => parseInt(hex, 16) - offset)
  return decimalArray
}

/**
 * 计算渐变颜色中间的任意位置的色值
 * @param {string} startColor 开始颜色, eg: '#C8FAD8'
 * @param {string} endColor 结束颜色, eg: '#4E85E1'
 * @param {number} percentage 0~1 百分比
 * @returns {string} 计算颜色结果
 */
export function lerpColor(startColor, endColor, percentage = 0) {
  function hexToRGB(hex) {
    return [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)]
  }

  function componentToHex(component) {
    const hex = component.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }

  try {
    const startRGB = hexToRGB(startColor)
    const endRGB = hexToRGB(endColor)

    const interpolatedRGB = startRGB.map((startComponent, i) => {
      const endComponent = endRGB[i]
      return Math.round((1 - percentage) * startComponent + percentage * endComponent)
    })

    const interpolatedColor = '#' + interpolatedRGB.map(componentToHex).join('')
    return interpolatedColor
  } catch (error) {
    console.log('error: ', error)
    return startColor
  }
}

/**
 * 计算渐变颜色中间的任意位置的色值
 * @param {string} startColor 开始颜色, eg: '#C8FAD8'
 * @param {string} midColor 中间颜色, eg: '#C8FAD8'
 * @param {string} endColor 结束颜色, eg: '#4E85E1'
 * @param {number} percentage 0~100 百分比
 * @returns {string} 计算颜色结果
 */
export function getColorFromPercentage(startColor, midColor, endColor, percentage) {
  // 颜色插值函数（线性插值）
  function lerp(start, end, t) {
    return start + (end - start) * t
  }

  // // 将 HEX 颜色转换为 RGB
  // function hexToRgb(hex) {
  //   const r = parseInt(hex.substring(1, 3), 16)
  //   const g = parseInt(hex.substring(3, 5), 16)
  //   const b = parseInt(hex.substring(5, 7), 16)
  //   return { r, g, b }
  // }

  // 将 RGB 转换为 HEX 颜色
  function rgbToHex(r, g, b) {
    return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase()}`
  }
  // 将 HEX 颜色转换为 RGB
  const minRgb = hexToRgb(startColor)
  const midRgb = hexToRgb(midColor)
  const maxRgb = hexToRgb(endColor)

  // 计算居中颜色的百分比位置
  let t
  let r, g, b

  if (percentage <= 0.5) {
    // 计算在最低颜色和中间颜色之间的位置
    t = percentage / 0.5 // 比例范围：[0, 1]
    r = Math.round(lerp(minRgb.r, midRgb.r, t))
    g = Math.round(lerp(minRgb.g, midRgb.g, t))
    b = Math.round(lerp(minRgb.b, midRgb.b, t))
  } else {
    // 计算在中间颜色和最高颜色之间的位置
    t = (percentage - 0.5) / 0.5 // 比例范围：[0, 1]
    r = Math.round(lerp(midRgb.r, maxRgb.r, t))
    g = Math.round(lerp(midRgb.g, maxRgb.g, t))
    b = Math.round(lerp(midRgb.b, maxRgb.b, t))
  }

  // 返回计算得到的颜色值
  return rgbToHex(r, g, b)
}

/**
 * 计算渐变颜色中间的任意位置的色值
 * @param {string} startColor 开始颜色, eg: '#C8FAD8'
 * @param {string} midColor 中间颜色, eg: '#C8FAD8'
 * @param {string} endColor 结束颜色, eg: '#4E85E1'
 * @param {number} percentage 0~100 百分比
 * @returns {string} 计算颜色结果
 */
export function getColorFromPercentageRGBA(startColor, midColor, endColor, percentage) {
  // 颜色插值函数（线性插值）
  function lerp(start, end, t) {
    return start + (end - start) * t
  }

  // 将 HEX 颜色转换为 RGB
  // function hexToRgb(hex) {
  //   const r = parseInt(hex.substring(1, 3), 16)
  //   const g = parseInt(hex.substring(3, 5), 16)
  //   const b = parseInt(hex.substring(5, 7), 16)
  //   return { r, g, b }
  // }

  // 将 RGB 转换为 HEX 颜色
  function rgbToHex(r, g, b) {
    return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase()}`
  }
  // 将 HEX 颜色转换为 RGB
  const minRgb = hexToRgb(startColor)
  const midRgb = hexToRgb(midColor)
  const maxRgb = hexToRgb(endColor)

  // 计算居中颜色的百分比位置
  let t
  let r, g, b

  if (percentage <= 0.5) {
    // 计算在最低颜色和中间颜色之间的位置
    t = percentage / 0.5 // 比例范围：[0, 1]
    r = Math.round(lerp(minRgb.r, midRgb.r, t))
    g = Math.round(lerp(minRgb.g, midRgb.g, t))
    b = Math.round(lerp(minRgb.b, midRgb.b, t))
  } else {
    // 计算在中间颜色和最高颜色之间的位置
    t = (percentage - 0.5) / 0.5 // 比例范围：[0, 1]
    r = Math.round(lerp(midRgb.r, maxRgb.r, t))
    g = Math.round(lerp(midRgb.g, maxRgb.g, t))
    b = Math.round(lerp(midRgb.b, maxRgb.b, t))
  }

    // 将 RGB 转换为 RGBA 颜色
    function rgbToRgba(r, g, b, a) {
      return `rgba(${r}, ${g}, ${b}, ${a})`
    }

  // 返回计算得到的颜色值
  return rgbToRgba(r, g, b, 1)
}

export function showCheckedMaxTips(source = '', target = '') {
  let param = source
  if (param.indexOf('#') >= 0) {
    param = param.split('#')
    if (param.length == 3) {
      param = param[0] + target + param[2]
      return param
    }
  }

  return source
}

export function lightStatus(data) {
  if (data?.StatusInfo) {
    if (getdeviceImageStatus(data, '0X0100', '0')) {
      return 'offline'
    } else if (getdeviceImageStatus(data, '0X02', '0') === true) {
      return 'off'
    } else {
      return 'on'
    }
  }
  return 'on'
}

function isChineseChar(char) {
  // 判断一个字符是否为中文字符
  return /[\u4e00-\u9fa5]/.test(char)
}

function charToGPK(char) {
  // 将一个中文字符转换为GPK编码
  const charCode = char.charCodeAt(0).toString(16).toUpperCase()
  return '0x' + '0000'.substring(0, 4 - charCode.length) + charCode
}

function charToHex(char) {
  // 将一个英文字符转换为十六进制表示
  const charCode = char.charCodeAt(0).toString(16).toUpperCase()
  return '0x' + '00'.substring(0, 2 - charCode.length) + charCode
}

function stringToHex(str, maxBytes) {
  let utf8Bytes = []
  let totalBytes = 0
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i)
    let byteCount = 0
    if (code < 0x80) {
      utf8Bytes.push(code) // 单字节字符
      byteCount = 1
    } else if (code < 0x800) {
      utf8Bytes.push((code >> 6) | 0xc0, (code & 0x3f) | 0x80) // 双字节字符
      byteCount = 2
    } else if (code >= 0xd800 && code <= 0xdbff) {
      // 处理代理对
      const nextCode = str.charCodeAt(++i)
      const surrogate = 0x10000 + ((code - 0xd800) << 10) + (nextCode - 0xdc00)
      utf8Bytes.push((surrogate >> 18) | 0xf0, ((surrogate >> 12) & 0x3f) | 0x80, ((surrogate >> 6) & 0x3f) | 0x80, (surrogate & 0x3f) | 0x80)
      byteCount = 4
    } else {
      utf8Bytes.push((code >> 12) | 0xe0, ((code >> 6) & 0x3f) | 0x80, (code & 0x3f) | 0x80) // 三字节字符
      byteCount = 3
    }

    // 检查总字节长度
    if (maxBytes && totalBytes + byteCount > maxBytes) {
      // 如果超过最大字节数，回退到最后一个有效字符
      utf8Bytes.length -= byteCount  // 截去多余的字节
     // utf8Bytes = utf8Bytes.slice(0, utf8Bytes.length - byteCount)
      break
    }
    totalBytes += byteCount
  }
  let hexString = utf8Bytes.map(byte => byte.toString(16).toUpperCase()).join('')
  console.log('..........hexString', str, hexString)

  return {
    hexString,
    byteLength: totalBytes,
  }
}

//字符串转UTF8,支持最大最小
/**
 * @param {*} str 需要转译的字符串
 * @param {*} max 字节数(不足补0,多余裁剪)
 * @param {*} isGpk 是否转为UTF8
 * @param {*} isHandle 是否处理
 */
export function jsToUTF8(str, max, isGpk = false, isHandle = true) {
  if (!str && str !== 0) return ''
  if (isGpk) {
    const { hexString, byteLength } = stringToHex(str, max)
    return { hexString, byteLength }
  } else {
    let hexString = str
    if (typeof str === 'number' && isHandle) {
      hexString = str.toString(16) + ''
    }
    if (hexString.startsWith('0x')) {
      hexString = hexString.slice(2)
    }
    if (typeof max === 'number' && isHandle) {
      // 计算当前长度
      const currentLength = hexString.length
      const max_ = max * 2

      // 如果当前长度小于max，用零补齐
      if (currentLength < max_) {
        hexString = '0'.repeat(max_ - currentLength) + hexString
      }

      // 如果当前长度超过max，截断至max个字符
      if (currentLength > max_) {
        hexString = hexString.slice(-max_)
      }
    }
    return hexString
  }
}
/**
 * wifi设备的状态 前两个字节是长度,后面是值,以此类推
 * @param {*} hexString 
 * @returns 
 */
export function parseHexString(hexString) {
  if (!hexString)
    return {
      value: '',
      next: '',
    }

  // 提取前一个字节，转换为十进制长度
  const lengthHex = hexString.slice(0, 2)
  const length = parseInt(lengthHex, 16)

  // 提取后面的值
  const str_length = 2 + length * 2
  const valueHex = hexString.slice(2, str_length) // 每个字节用两个十六进制字符表示

  // 将十六进制字符串转换为字节数组
  const bytes = new Uint8Array(length)
  for (let i = 0; i < length; i++) {
    bytes[i] = parseInt(valueHex.substr(i * 2, 2), 16)
  }

  // 使用 TextDecoder 将字节数组解码为 UTF-8 字符串
  const decoder = new TextDecoder('utf-8')
  const result = decoder.decode(bytes)

  let next = ''
  if (hexString.length > str_length) {
    next = hexString.slice(str_length)
  }

  return {
    value: result,
    next,
  }
}
/**
 * 获取设备列表内所有的classsku以及版本号组合
 */
export function getClassSkuAndVersion(data) {
  console.log('.....获取设备列表内所有的classsku以及版本号组合')
  if(data && data.length > 0) {
    let _param = {}
    data.forEach(item => {
      const {ClassSku,LocalVersion} =item
        //增加classsku 版本号进行接口匹配查询
       if(ClassSku && !_param[ClassSku]){
          _param[ClassSku] = []
        }
       if( LocalVersion !==undefined && LocalVersion !==null ){
          _param[ClassSku].push(LocalVersion)
        }

    })
    //去重
    let list = []
    for (let key in _param) {
      if (_param.hasOwnProperty(key)) {
        let parm = {
          ClassSku: key,
          FirmVersions: [...new Set(_param[key])],
        }
        list.push(parm)
      }
    }
    return list
  }
  return []
}


/**
 * 比较两个字符串数组是否包含相同的元素（顺序无关）
 * @param {Array<string>} arr1 - 第一个数组
 * @param {Array<string>} arr2 - 第二个数组
 * @returns {boolean} - 如果两个数组包含相同的元素（顺序无关），则返回true，否则返回false
 */
export function areArraysEqualIgnoreOrder(arr1, arr2) {
  // 如果两个数组长度不同，直接返回false
  if (arr1.length !== arr2.length) {
      return false;
  }
  
  // 创建一个对象来记录每个元素的出现次数
  const elementCount = {};
  
  // 统计第一个数组中每个元素的出现次数
  for (const element of arr1) {
      elementCount[element] = (elementCount[element] || 0) + 1;
  }
  
  // 检查第二个数组中的元素
  for (const element of arr2) {
      // 如果元素不存在或计数已经为0，返回false
      if (!elementCount[element]) {
          return false;
      }
      elementCount[element]--;
  }
  
  // 如果所有检查都通过，返回true
  return true;
};

// 生成 date 位
export function buildDate(days = []) {
  return days.reduce((acc, d) => acc | (1 << (d - 1)), 0);
}

// 生成 month 位
export function buildMonth(months = []) {
  return months.reduce((acc, m) => acc | (1 << (m - 1)), 0);
}

/**
 * 将 date 位掩码解析为“天数组”
 * @param {number} dateValue - 后端返回的 date（uint32）
 * @returns {number[]} [1, 5, 10]
 */
export function parseDate(dateValue) {
  // 兜底：空 / 非数字
  if (typeof dateValue !== 'number' || dateValue <= 0) return [];

  // 全选（32位全1，但只取1~31）
  if (dateValue === 0xFFFFFFFF) {
    return Array.from({ length: 31 }, (_, i) => i + 1);
  }

  const result = [];

  // 只遍历 1~31 位（bit0 ~ bit30）
  for (let i = 0; i < 31; i++) {
    if ((dateValue & (1 << i)) !== 0) {
      result.push(i + 1);
    }
  }

  return result;
}

/**
 * 将 month 位掩码解析为“月份数组”
 * @param {number} monthValue - 后端返回的 month（uint16）
 * @returns {number[]} [2, 6]
 */
export function parseMonth(monthValue) {
  // 兜底
  if (typeof monthValue !== 'number' || monthValue <= 0) return [];

  // 全选（低12位全1）
  if (monthValue === 0xFFFF) {
    return Array.from({ length: 12 }, (_, i) => i + 1);
  }

  const result = [];

  // 只遍历 1~12 月（bit0 ~ bit11）
  for (let i = 0; i < 12; i++) {
    if ((monthValue & (1 << i)) !== 0) {
      result.push(i + 1);
    }
  }

  return result;
}